export const AppRowIds = {
  ZOOM: 'zoom-app',
  // TODO(sleahy): Add other app row ids here
} as const;

export type AppRowId = (typeof AppRowIds)[keyof typeof AppRowIds];
